export const arrayCheckSet = (value, property) => Array.isArray(value[property]) ? value[property] : [value[property]];
